export enum OKRCategories {
    None = "",// Empty Category is used when scenario action does not map to a OKR category.
    Seen = "Seen",
    Closed = "Closed",
    Tried = "Tried",// Used when action triggers LLM directly
    TriedInitiate = "Tried_Initiate",// Used when action triggers bizchat, which in turn triggers LLM. Introduced Oct 2025.
    TriedResponse = "Tried_Response",
    Kept = "Kept",
    // User continued from an on-canvas card into a follow-up (Turn-2) BizChat experience.
    Turn2Click = "Turn2Click",
    // First usable response received from the model (first token / UPLT).
    ResponseReceived = "ResponseReceived",
    // Final response fully rendered (last token).
    ResponseRendered = "ResponseRendered",
    ThumbsUp = "ThumbsUp",
    ThumbsDown = "ThumbsDown",
    Discard = "Discard",
    Analysis = "Analysis"
}
